import InvestmentProfileWidget from './InvestmentProfileWidget'

export default InvestmentProfileWidget
